import React from 'react';
import { Helmet } from 'react-helmet';

const tourData = [
  {
    title: "Swift Desire",
    image: "/images/ourfleet/1.jpg",
    seater: "4+1",
    driverAllowance: "₹500",
    perKm: "₹12",
    extraHr: "₹150",
    nightHalt: "₹250",
  },
  {
    title: "Ertiga",
    image: "/images/ourfleet/2.jpg",
    seater: "6+1",
    driverAllowance: "₹500",
    perKm: "₹15",
    extraHr: "₹150",
    nightHalt: "₹250",
  },
  {
    title: "Innova Crysta ",
    image: "/images/ourfleet/4.jpg",
    seater: "6+1",
    driverAllowance: "₹500",
    perKm: "₹20",
    extraHr: "₹150",
    nightHalt: "₹250",
  },
  {
    title: "Kia Carens",
    image: "/images/ourfleet/5.jpg",
    seater: "6+1",
    driverAllowance: "₹500",
    perKm: "₹17",
    extraHr: "₹150",
    nightHalt: "₹250",
  },
  {
    title: "Innova Cab ",
    image: "/images/ourfleet/in.jpg",
    seater: "6+1",
    driverAllowance: "₹500",
    perKm: "₹18",
    extraHr: "₹150",
    nightHalt: "₹250",
  },
  {
    title: " Scorpio",
    image: "/images/ourfleet/3.jpg",
    seater: "8+1",
    driverAllowance: "₹500",
    perKm: "₹18",
    extraHr: "₹150",
    nightHalt: "₹250",
  },
  {
    title: "Tempo Traveller",
    image: "/images/ourfleet/7.jpg",
    seater: "17",
    driverAllowance: "₹500",
    perKm: "₹25",
    extraHr: "₹150",
    nightHalt: "₹250",
  },
  {
    title: " Mini Bus",
    image: "/images/ourfleet/8.jpg",
    seater: "32",
    driverAllowance: "₹500",
    perKm: "₹35",
    extraHr: "₹150",
    nightHalt: "₹250",
  },
  {
    title: " Luxury Bus",
    image: "/images/ourfleet/9.jpg",
    seater: "35",
    driverAllowance: "₹500",
    perKm: "On Call",
    extraHr: "₹150",
    nightHalt: "₹250",
  },
  {
    title: " Urbania ",
    image: "/images/ourfleet/10.webp",
    seater: "13",
    driverAllowance: "₹500",
    perKm: "₹38",
    extraHr: "₹150",
    nightHalt: "₹250",
  },
  {
    title: " 35 Seater Bus",
    image: "/images/ourfleet/12.webp",
    seater: "35",
    driverAllowance: "₹500",
    perKm: "On Call",
    extraHr: "₹150",
    nightHalt: "₹250",
  },
  {
    title: " Volvo Bus",
    image: "/images/ourfleet/13.jpg",
    seater: "40",
    driverAllowance: "₹500",
    perKm: "On Call",
    extraHr: "₹150",
    nightHalt: "₹250",
  },

];

const Booking = () => {
  const handleBookNow = (tourTitle) => {
    const phoneNumber = "+918850328441";
    const message = `I want to Book ${tourTitle} With S9 Travels. Request you Please Send More Details or Call Me. Thank you. `;
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  const productSchema = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Pune to Mumbai Cab",
    "description": "Book your comfortable Pune to Mumbai cab for a smooth and hassle-free journey. Choose from one-way, round trip, and group travel options with both affordable and luxury cabs.",
    "aggregateRating": {
      "@type": "AggregateRating",
      "bestRating": "5",
      "worstRating": "1",
      "ratingValue": "4.7",
      "ratingCount": "450"
    }
  };

  return (
    <>
      <Helmet>
        <title>Pune to Mumbai Cab | S9 Travels | Contact: +91 8850328441</title>
        <meta 
          name="description" 
          content="Book a reliable cab for your Pune to Mumbai journey. Affordable and luxury cabs available for one-way, round-trip, and group travel services." 
        />
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>

      <section className="page-title centred">
        <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
        <div className="auto-container">
          <div className="content-box">
            <h1>Online Booking</h1>
          </div>
        </div>
      </section>

      <section className="space">
        <div className="container">
          <div className="row">
            {tourData.map((tour, index) => (
              <div key={index} className="col-md-4 py-4">
                <div className="tour-box th-ani">
                  <div className="tour-box_img global-img ">
                    <img src={tour.image} alt={tour.title} />
                  </div>
                  <div className="tour-content bg-darkk">
                    <h3 className="box-title">
                      <h4 href={tour.detailLink} className="darkcolor text-center">{tour.title}</h4>
                    </h3>
                    <div className="tour-details">
                      <div className="tour-detail-item" style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <span className="detail-label"><strong>Seater:</strong></span>
                        <span className="detail-value">{tour.seater.replace('+', ' + ')}</span>
                      </div>
                      <div className="tour-detail-item" style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <span className="detail-label"><strong>Per Km:</strong></span>
                        <span className="detail-value">{tour.perKm.replace(/(\d)(₹)/, '$1 $2')}</span>
                      </div>
                      <div className="tour-detail-item" style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <span className="detail-label"><strong>Extra Hr:</strong></span>
                        <span className="detail-value">{tour.extraHr.replace(/(\d)(₹)/, '$1 $2')}</span>
                      </div>
                      <div className="tour-detail-item" style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <span className="detail-label"><strong>Night Halt:</strong></span>
                        <span className="detail-value">{tour.nightHalt.replace(/(\d)(₹)/, '$1 $2')}</span>
                      </div>
                    </div>

                    <div className="tour-action text-center">
                      <button
                        onClick={() => handleBookNow(tour.title)}
                        className="th-btn"
                      >
                        Book Now
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Booking;
